/**
 * Feature flag module keys used by the backend/package to enable or disable
 * parts of the app (e.g. workflows, email integration, saved views).
 * Use these constants instead of string literals when calling useModuleFlag()
 * or ProtectedRoute moduleKey.
 */
export enum ModuleKey {
  EmailIntegration = 'email_integration',
  SavedViews = 'saved_views',
  Workflow = 'workflow',
}

/**
 * Default enabled state for each module when the flag is not yet loaded.
 * Must match backend/package defaults.
 */
export const MODULE_DEFAULT_ENABLED: Record<ModuleKey, boolean> = {
  [ModuleKey.EmailIntegration]: true,
  [ModuleKey.SavedViews]: true,
  [ModuleKey.Workflow]: true,
}
